import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from 'environments-lib';
import { IEnvironment, TemplateWorkflowConfig } from 'interfaces-lib';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DefaultTemplateService {
  constructor(
    private http: HttpClient,
    @Inject(ENVIRONMENT) private environment: Partial<IEnvironment>
  ) {}

  getTemplatesByEntity(recordEntity: string): Observable<TemplateWorkflowConfig[]> {
    return this.http.get<TemplateWorkflowConfig[]>(
      `${this.environment.kpHost}/adv2/workflowconfig/${recordEntity}?isDocmerge=true`
    );
  }
}
